module.exports = __webpack_public_path__ + "static/media/chip2.3bb7d3c9.png";